import React, { Component } from 'react';
import { Form, Row,  Col, message, Switch, Button } from "antd";
import connect from "react-redux/es/connect/connect";
import { hashHistory, Link } from 'react-router';
import moment from 'moment';

import DateTime from "../../../../components/Items/DateTime";
import ImageUpload from "../../../../components/Items/ImageUploader";
import Input from '../../../../components/UI/Input/Input';

import { updateObject } from '../../../../shared/utility';

import { updateExistingEvent, uploadNewEvent } from "../../../../services/firebase/events";
import { getConnectedAccountInfo } from "../../../../services/firebase/firebase";

import { addEventAction, updateEventAction } from "../../../../actions/eventsStoreActions";

import controlsConfig from './ControlsOptionsConfig';

import UploadVideo from './UploadVideo';
import Buttons from './Buttons';

import './EventForm.less'

class EventForm extends Component {
  constructor(props){
    super(props);

    const { item } = props;
    const { embedType, youTubeUrl, videoEmbed } = item;
    let valueForEmbedType = 'youtube';

    if (!embedType || (embedType && embedType.length === 0)) { // if we haven't embedType (possible in old events)
      if (videoEmbed && videoEmbed.id) {
        valueForEmbedType = 'ustream'
      } else if (youTubeUrl) {
        valueForEmbedType = 'youtube';
      } else {
        valueForEmbedType = 'upload';
      }
    }

    let noChannelsBlocker = false;
    let channelList = [];
    if (props.userClaims.userType && props.userClaims.userType === "Contributor") {
      channelList = props.ownChannel;
      noChannelsBlocker = Array.isArray(props.ownChannel) && props.ownChannel.length === 0;
    }
    if (props.userClaims.userType && props.userClaims.userType === "Admin") {
      channelList = props.channelsList;
    }

    const controlsOptions = {
      item,
      channelList,
      valueForEmbedType
    };

    this.state = {
      controls: controlsConfig(controlsOptions),
      noChannelsBlocker: noChannelsBlocker,
      valueType: item.type,
      sending: false,
      thumbnail: (item.thumbnail && item.thumbnail.live) || item.thumbnail,
      thumbnailName: props.item.thumbnailName || '',
      isImageDataSent: true,
      selectDate: '',
      notificationPeriod: item.notificationPeriod,
      videoEmbed: !!item.videoEmbed,
      playlist: !!item.playlist,
      fileList: [],
      deletingEvent: false,
      values: item,
      error: '',
      uploadVideo: item.uploadVideo || {},
      accountCard: null
    };

    this.defaultState = {...this.state};
    this.dateChange = this.dateChange.bind(this);
    this.handleAddPaidAccess = this.handleAddPaidAccess.bind(this);
    this.handleAddEventCost = this.handleAddEventCost.bind(this);
  }

  componentDidMount() {
    const { newElement, user } = this.props;

    // GET DATA FOR CHECKING POSSIBILITIES ADD PAYMENTS TYPE
    if (newElement && user && user.userData && user.userData.stripeAccountId) {
      const { stripeAccountId } = user.userData;
      getConnectedAccountInfo(stripeAccountId)
        .then((account) => {
          if (account && account.accountInfo && account.accountInfo.external_accounts) {
            const card = account.accountInfo.external_accounts.data[0] || null;

            this.setState({ accountCard: card })
          }

          message.success('Got actual Stripe info.');
        })
        .catch(() => message.error("Can't connect to Stripe server. Please try later."))
    }
  }

  inputChangeHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target ? event.target.value : event,
        // valid: checkValidaty(event.target.value, this.state.controls[controlName.validation]),
        touched: true
      })
    });
    this.setState({controls: updatedControls});
  };

  checkHttps(embedLink) {
    const regexpTemplate = /^https:\/\/(www\.)?/;
    const matched = embedLink.search(regexpTemplate);

    let url;
    if (matched === -1) {
      url  = `https://${embedLink}`;
    } else {
      url  = embedLink;
    }

    return url
  }

  async save(e) {
    e.preventDefault();
    if (!this.validateFields()) return;

    const { item } = this.props;
    const { title, type, description, tags, channel, embedLinkYouTube, embedLinkUstream, embedTypeRadioButtons } = this.state.controls;
    const { uploadVideo } = this.state;

    const values = {
      ...this.state.values,
      title: title.value,
      type: type.value,
      description: description.value,
      channel: channel.value,
      embedType: embedTypeRadioButtons.value,
      tags: tags.value,
      uploadVideo: uploadVideo,
    };

    if (!item.isUpcoming) {
      if (embedLinkYouTube && embedLinkYouTube.value) {
        values.youTubeUrl = this.checkHttps(embedLinkYouTube.value);
      }

      if (embedLinkYouTube.touched && !embedLinkYouTube.value) {
        values.youTubeUrl = null;
      }

      if (embedLinkUstream && embedLinkUstream.value) {
        let ustreamUrl = this.checkHttps(embedLinkUstream.value);
        const ustreamTemplate = /^(https?:\/\/)?(www\.)?ustream.tv\/(embed\/)?recorded\//;
        const splitedUrl = ustreamUrl.split(ustreamTemplate);

        let ustreamId;
        splitedUrl.forEach(item => {
          switch (item) {
            case '':
            case "https://":
            case "www.":
            case "embed/":
              break;
            default:
              ustreamId = item;
          }
        });

        values.videoEmbed = {
          id: ustreamId
        };
      }

      if (embedLinkUstream.touched && !embedLinkUstream.value) {
        values.videoEmbed = null;
      }
    }

    if (this.props.newElement) {
      let newEventInfo;
      this.setState({sending: true});
      values.views = 0;

      await uploadNewEvent(values)
        .then((data) => {
          newEventInfo = data;
          this.props.addEventAction(values);
        })
        .then(() => {
          message.success('Event created');

          this.setState({...this.defaultState, isImageDataSent: true});
          newEventInfo && newEventInfo.eventId &&
            hashHistory.push(`/watch/${newEventInfo.eventId}`);
        })
        .catch(err => {
          console.error('error', err);
          message.error(err);

          this.setState({sending: false, error: err});
        });

    } else {
      if (Number.isNaN(values.views)) {
        values.views = 0;
      }

      await this.editEvent(values); // using this action when upload existing Event
                                   // and when uploading Image (updating event data in database)

      this.props.item && this.props.item.id && hashHistory.push(`/watch/${this.props.item.id}`);
    }
  };

  async editEvent(values, downloadURL, thumbnailName) {
    if (downloadURL && thumbnailName) {
      let valuesWithImage = {
        ...values,
        thumbnail: downloadURL,
        thumbnailName: thumbnailName,
      };

      await updateExistingEvent(valuesWithImage, 'upcoming')
        .then(() => {
          this.props.updateEventAction(values);
        })
        .then(() => {
          message.success('Event edited');
          this.setState({
            values: {
              ...this.state.values,
              thumbnail: downloadURL,
              thumbnailName: thumbnailName,
            },
          });
        })
        .catch(err => {
          message.error(err);
          this.setState({sending: false, error: err});
          console.error('error', err);
        });
    } else {
      await updateExistingEvent(values, 'upcoming')
        .then(() => {
          this.props.updateEventAction(values);
        })
        .then(() => {
          message.success('Event edited');

          this.setState({sending: false, isImageDataSent: true})
        })
        .catch(err => {
          message.error(err);
          this.setState({sending: false, error: err});
          console.error('error', err);
        });
    }
  };

  validateFields() {
    const { embedLinkYouTube, embedLinkUstream,  title, channel } = this.state.controls;

    if (embedLinkYouTube && embedLinkYouTube.value) {
      let errMessage = 'Sorry, but video URL field is incorrect. Format for YouTube Url https://www.youtube.com/embed/*'
      let regexpTemplate = /^(https:\/\/)?(www\.)?youtube.com\/embed\/\S+/;
      let matched = embedLinkYouTube.value.search(regexpTemplate);

      if (matched === -1) {
        message.warn(errMessage);
        return false
      }
    }

    if (embedLinkUstream && embedLinkUstream.value) {
      let errMessage = 'Sorry, but video URL field is incorrect. Format for Ustream Url https://www.ustream.tv/embed/recorded/*';
      let regexpTemplate = /^(https?:\/\/)?(www\.)?ustream.tv\/(embed\/)?recorded\S+/;
      let matched = embedLinkUstream.value.search(regexpTemplate);

      if (matched === -1) {
        message.warn(errMessage);
        return false
      }
    }

    if (title.value.length > 100) {
      message.warn('Title must not exceed 100 characters');
      return false;
    }

    if (!channel.value) {
      message.warn('Channel is required');
      return false
    }

    return true
  };

  updateValue = (target, value) => {
    this.setState({
      values: {
        ...this.state.values,
        [target]: value,
      },
    });
  };

  dateChange(date) {
    let changingDateByStart = moment(date).startOf('day');
    let localTime = moment(changingDateByStart).format('YYYY-MM-DD');
    let proposedDate = localTime + "T14:00:00.000Z";
    let addedHoursToEvening = moment(proposedDate);

    this.updateValue('date', addedHoursToEvening)
  };

  setStateHandler = (obj) => {
    this.setState(obj);
  };

  handleUpdateImage(url, thumbnailName) {
    message.success('Image uploaded. Please, save form');
    this.setState({
      values: {
        ...this.state.values,
        thumbnail: url,
        thumbnailName: thumbnailName,
        isImageDataSent: false,
      },
    });
  }

  handleAddPaidAccess(checked) {
    this.updateValue('paidBlock', checked ? 'blocked' : '')
  }

  handleAddEventCost(event) {
    this.updateValue('eventCost', event.target.value)
  }

  render() {
    const { item, newElement } = this.props;
    const { controls, values, noChannelsBlocker, accountCard } = this.state;
    const isHaveCard = accountCard && !!accountCard.id;

    const formElementsArray = [];
    for (let key in this.state.controls) {
      formElementsArray.push({
        id: key,
        config: this.state.controls[key]
      })
    }

    let form = formElementsArray.map(formElement => (
      <Input
        label={formElement.config.label}
        key={formElement.id}
        icon={formElement.config.icon}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        options={formElement.config.options}
        value={formElement.config.value}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        invalid={!formElement.config.valid}
        noShown={formElement.config.noShown}
        selectChange={(value, option) => this.inputChangeHandler({
          id: value,
          title: option.props.title
        }, formElement.id)}
        changed={(event) => this.inputChangeHandler(event, formElement.id)}
      />
    ));

    return (
      <Form onSubmit={this.save.bind(this)} className="edit-form">
        <Row type="flex">
          <Col
            xs={24}
            md={{ span: 11, push: 1, order: 2 }}
            className="center-column"
          >
            <ImageUpload
              className="avatar-uploader"
              uploadText="Add Avatar"
              uploadItemAction={(downloadURL, thumbnailName) => this.editEvent(this.state.values, downloadURL, thumbnailName)}
              imageUrl={this.state.values.thumbnail}
              newElement={newElement}
              thumbnailName={this.state.values.thumbnailName}
              isImageDataSent={this.state.isImageDataSent}
              onImageUpload={(url, thumbnailName) => this.handleUpdateImage(url, thumbnailName)}
            />
          </Col>
          <Col xs={24} md={12}>
            {noChannelsBlocker && (
              <div class="contributor-warning">
                Hmmm. Seems that you are a contributor but do not have an assigned channel. Please contact your administrator david@implantcompare.com to start creating events.
              </div>
            )}
            {
              form.slice(0,3) // fields: Event Type, Event Title, Event Channel
            }
          </Col>
        </Row>
        <Row type="flex">
          <Col
            xs={{ span: 24, order: 3 }}
            md={{ span: 11, push: 1, order: 2 }}
            className="center-column"
          >
            <Form.Item label="Event Date & Time" className="datepicker-item">
              <div className="datepicker-holder">
                <DateTime
                  item={values}
                  dateChange={this.dateChange}
                  editing={true}
                />
              </div>
            </Form.Item>

            <Form.Item label="Paid Event" className="paid-item">
              <div className="paid-item-holder">
                <Switch
                  defaultChecked={!!values.paidBlock}
                  onChange={this.handleAddPaidAccess}
                  disabled={!isHaveCard}
                />
              </div>
            </Form.Item>

            {
              (!isHaveCard) && (
                <Form.Item label="" className="paid-item unverified-info">
                  <p>For create a paid event, click HERE to verify your banking information.</p>

                  <Link to={'/Payments'}>
                    <Button >{'Move to Purchased'}</Button>
                  </Link>
                </Form.Item>
              )
            }

            <Form.Item className="paid-cost-item">
              <Input
                label={'Event cost (dollars)'}
                key={'eventCost'}
                elementType={'input'}
                value={values.eventCost}
                noShown={!values.paidBlock}
                changed={this.handleAddEventCost}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            {
              !item.isUpcoming && (
                <div className="ant-row ant-form-item">
                  <div className="ant-col ant-form-item-label">
                    <label
                      className="label-question"
                      title="Select video source (Only one can be selected)"
                    >
                      Select video source (Only one can be selected)
                    </label>
                  </div>
                  <div className="ant-col ant-form-item-control-wrapper">
                    <div className="ant-form-item-control">
                      {
                        form.slice(3,4) // fields: Select video source
                      }
                      {
                        controls.embedTypeRadioButtons.value === "youtube" && (
                          form.slice(4,5) // fields: YouTube input
                        )
                      }
                      {
                        controls.embedTypeRadioButtons.value === "ustream" && (
                          form.slice(5,6) // fields: Ustream input
                        )
                      }
                      {
                        controls.embedTypeRadioButtons.value === "upload" && (
                          <div>
                            <UploadVideo
                              userClaims={this.props.userClaims}
                              ownChannel={this.props.ownChannel}
                              state={this.state}
                              item={item}
                              setStateHandler={this.setStateHandler}
                              updateValue={this.updateValue}
                            />
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
            }

            {
              form.slice(7) // fields: Event Description, Restriction, Tags
            }
          </Col>
        </Row>
        <Buttons newElement={this.props.newElement} noChannelsBlocker={noChannelsBlocker} item={item} setStateHandler={this.setStateHandler} />
      </Form>
    );
  }
}

export default connect(
  state => ({ user: state.user }),
  { addEventAction, updateEventAction }
)(EventForm);



// WEBPACK FOOTER //
// ./src/pages/EventEditor/Content/EventForm/index.js